import { useEffect, useState } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import PageContainer from "../../Components/Page/PageContainer";
import { TabMenu } from "primereact/tabmenu";
import { Card } from "primereact/card";
import { ROUTES } from "../../config/routes";

const CompositionAudits = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState<number>(0);

  // Sync active tab with current route
  useEffect(() => {
    const path = location.pathname;
    // Set active tab based on current route
    if (path.includes(ROUTES.UMPG_SYNC_AUDIT)) {
      setActiveIndex(0);
    } else if (path.includes(ROUTES.COMPOSITION_GENERAL_INSPECTION)) {
      setActiveIndex(1);
    } else if (path.includes(ROUTES.COMPOSITION_METADATA_AUDIT_COMPARER)) {
      setActiveIndex(2);
    } else {
      setActiveIndex(-1); // No tab selected for dashboard
    }
  }, [location.pathname]);

  const handleTabChange = (e: any) => {
    if (e.index === 0) {
      navigate(ROUTES.UMPG_SYNC_AUDIT);
    } else if (e.index === 1) {
      navigate(ROUTES.COMPOSITION_GENERAL_INSPECTION);
    } else if (e.index === 2) {
      navigate(ROUTES.COMPOSITION_METADATA_AUDIT_COMPARER);
    }
  };

  const items = [
    { label: "UMPG Sync Audit", icon: "pi pi-sync" },
    { label: "General Inspection", icon: "pi pi-search" },
    { label: "Composition Metadata Audit", icon: "pi pi-list" },
  ];

  return (
    <PageContainer
      HomeMenuBarprops={{
        title: (
          <span
            style={{ cursor: "pointer", fontWeight: "bold" }}
            onClick={() => navigate(ROUTES.COMPOSITION_ASSETS)}
          >
            Composition Assets
          </span>
        ),
        Tabs: (
          <TabMenu
            activeIndex={activeIndex}
            onTabChange={handleTabChange}
            model={items}
          />
        ),
      }}
    >
      <div
        style={{
          width: "96%",
          margin: "0 auto",
        }}
      >
        <Card
          unstyled
          style={{
            marginTop: "2rem",
            boxShadow: "none",
          }}
        >
          {/* Use Outlet for sub-routes */}
          <Outlet />
        </Card>
      </div>
    </PageContainer>
  );
};

export default CompositionAudits;
